<template>
  <div class="data-retrieval-main">
    <div class="top-area">
      <Input textType="file" placeholder="Choose Files" @fileChanged="fileChanged2" :multiFile="true" />
      <button @click="createExcel" :disabled="allDataRetrieved.length == 0 || isExportingToExcel"
        style="margin-right: 5px; background-color: #6eef6e; white-space: nowrap">
        {{ isExportingToExcel ? 'Exporting' : 'Export To Excel' }}
      </button>
      <button @click="submitClicked" :disabled="allDataRetrieved.length == 0">Submit</button>
    </div>
    <div class="table-area">
      <!-- <button v-for="(p, i) in pdfFiles" :key="i" @click="viewClicked(selectedIndex == i ? -1 : i)">View</button> -->
      <div class="data-retrieval-row" style="position: sticky; background-color: white; z-index: 1; top: 0">
        <div class="data-retrieval-column-width column-stick-left">
        </div>
        <div class="data-retrieval-column-width" v-for="(h, i) in headers" :key="i">{{ h }}</div>
      </div>
      <div class="data-retrieval-row" v-for="(a, ai) in allDataRetrieved" :key="ai" :style="{ height: selectedIndex == ai ? '50%' : '' }">
        <div class="data-retrieval-column-width column-stick-left" :style="{ backgroundColor: selectedIndex == ai ? 'orange' : '' }">
          <button @click="viewClicked(selectedIndex == ai ? -1 : ai, a['_uploaded_file_name'])">{{ selectedIndex == ai ? 'X' : 'View' }}</button>
        </div>
        <div class="data-retrieval-column-width" v-for="(h, i) in headers" :key="i" :style="{ backgroundColor: selectedIndex == ai ? 'orange' : '' }">
          <textarea v-model="a[h]"></textarea>
        </div>
      </div>
    </div>
    <div class="pdf-area">
      <div v-if="!selectedFile">Click View to View the pdf file</div>
      <object v-else :data="selectedFile" type="application/pdf"></object>
      <div v-if="selectedFile" class="table-by-file-section">
        <div>Tables Found in this file: {{ selectedFileTables.length }} table(s)</div>
        <div class="table-buttons">
          <button v-for="(t, ti) in selectedFileTables" :key="ti" :class="{ 'active-button': selectedFileTableIndex == ti }"
            @click="selectedFileTableClicked(ti)">Table {{ ti + 1 }}</button>
        </div>
        <div class="table-area" style="max-height: 100%" v-if="selectedFileTableIndex >= 0">
          <div class="data-retrieval-row" style="position: sticky; background-color: white; z-index: 1; top: 0">
            <div class="data-retrieval-column-width" v-for="(k, ki) in pdfTableKeys" :key="ki">{{ k }}</div>
          </div>
          <div class="data-retrieval-row" v-for="(p, pi) in pdfTableValues" :key="pi">
            <div class="data-retrieval-column-width" v-for="(k, ki) in pdfTableKeys" :key="ki">
              <textarea v-model="p[k]"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import AllForms from '@/js/allforms.json';
// import AllKeys from '@/js/allkeys.json';
// import AllTables from '@/js/alltables.json';
import { PDFDocument } from 'pdf-lib'
import XLSX from "xlsx-js-style";

export default {
  components: {
  },
  data: function() {
    return {
      allDataRetrieved: [],
      headers: [],
      selectedIndex: -1,
      pdfFiles: [],
      pdfFilesTables: [],
      selectedFile: null,
      selectedFileTables: null,
      selectedFileTableIndex: -1,
      isExportingToExcel: false,

      pdfTableKeys: [],
      pdfTableValues: [],
    }
  },
  props: {
  },
  methods: {
    fileChanged: async function(e) {
      let allForms = [];
      let allKeys = [];

      this.pdfFiles = [];
      for (let f of Array.from(e)) {
        this.pdfFiles.push(await this.checkAndSplitPDF(f));
      }
      this.pdfFiles = this.pdfFiles.flat();

      let totalSizeInMB = this.pdfFiles.map(p => p['file']['size']).reduce((a, b) => a + b, 0) / 1000 / 1000;
      let remainingSize = totalSizeInMB;

      let date = new Date().getTime();
      for (let x = 0; x < this.pdfFiles.length; x++) {
        let f = this.pdfFiles[x];
        let timeRemaining = (this.pdfFiles.length - x) * 7;

        this.$fullscreenLoading(`Uploading ${f.name} (${x + 1} of ${this.pdfFiles.length})<br>Uploading ${totalSizeInMB.toFixed(2)}MB in total<br>Remaining ${remainingSize.toFixed(2)}MB (~${timeRemaining > 60 ? `${Math.ceil(timeRemaining / 60)} min(s)` : `${timeRemaining.toFixed(0)} sec(s)`} left)`, true);
        let formData = new FormData();
        formData.append('file', f['file']);
        let result = await this.$apiCallV2('/Verification/ReadFile', formData);
        allForms.push(result['combinedForms']);
        allKeys.push(result['combinedForms'].map(c => c['key']));

        remainingSize -= (f['file']['size'] / 1000 / 1000);
      }
      this.$fullscreenLoading();
      console.log((new Date().getTime() - date) / 1000);
      
      allForms = this.$deepTrimJsonV3(allForms);
      allKeys = this.$deepTrimJsonV3(allKeys);
      
      //#region Removing the start and end colon for all the keys
      allKeys = allKeys.flat().map(k => this.removeColon(k));
      //#endregion

      //#region Removing the start and end colon for the the keys and values in each form
      allForms.forEach(form => {
        form.forEach(f => {
          f['key'] = this.removeColon(f['key']);
          f['value'] = this.removeColon(f['value']);
        });
      })
      //#endregion

      let newForms = Array(allForms.length);
      allKeys = [...new Set(allKeys)];
      for (let x = 0; x < newForms.length; x++) {
        newForms[x] = {};
        allKeys.forEach(h => {
          let hasKey = allForms[x].find(f => f['key'] == h);
          if (h.includes('Job #')) {
            if (hasKey) {
              let value = hasKey['value'] || '';
              if (hasKey['value'][1] == '1') {
                newForms[x][h] = `${value.substring(0,1)}I${value.substring(2)}`;
              } else {
                newForms[x][h] = value;
              }
            } else {
              newForms[x][h] = '';
            }
          } else {
            newForms[x][h] = hasKey ? hasKey['value'] : '';
          }
        })
      }

      this.headers = allKeys;
      this.allDataRetrieved = newForms;
    },
    viewClicked: async function(ind, name) {
      this.selectedIndex = ind;
      this.selectedFileTableIndex = -1;

      if (this.selectedIndex >= 0) {
        this.selectedFile = this.pdfFiles.find(f => f['name'] == name)['base64'];
        this.selectedFileTables = this.pdfFilesTables.find(t => t['name'] == name)['table'];
      } else {
        this.selectedFile = null;
        this.selectedFileTables = null;
      }
    },
    selectedFileTableClicked: function(ind) {
      if (this.selectedFileTableIndex == ind) {
        this.selectedFileTableIndex = -1;
      } else {
        this.selectedFileTableIndex = ind;
      }

      if (this.selectedFileTableIndex >= 0) {
        this.pdfTableValues = this.selectedFileTables[this.selectedFileTableIndex];
        this.pdfTableKeys = Object.keys(this.pdfTableValues[0]);
      }
    },
    submitClicked: function() {
    },
    removeColon: function(str) {
      if (str.startsWith(':')) {
        str = str.substring(1);
        str = str.trim();
      }
      if (str.endsWith(':')) {
        str = str.substring(0, str.length - 1);
        str = str.trim();
      }
      return str;
    },
    createExcel: async function() {
      let title = `PDFs_${new Date().formatString('yyyyMMdd_HHmm')}`;
      let excelStartDate = new Date().getTime();
      let createFormattedExcel = true;
      this.isExportingToExcel = true;

      if (createFormattedExcel) { // Create excel based on the template by Ms Lim
        let formattedPDF = JSON.parse(JSON.stringify(this.pdfFiles));
        formattedPDF.forEach(f => {
          let table = this.pdfFilesTables.find(p => p['name'] == f['name']);
          let fullData = this.allDataRetrieved.find(a => a['_uploaded_file_name'] == f['name']);
          f['tables'] = table ? table['table'] : [];
          f['fullData'] = fullData;
        });
        
        let formattedResult = formattedPDF.map(f => {
          let flatTables = JSON.parse(JSON.stringify(f['tables'])).flat();
          let invoiceTable = flatTables.filter(ft => {
            let hasRate = Object.keys(ft).find(k => k.match(/tax rate/gi) || k.match(/rate description/gi));
            return hasRate || false;
          });

          let result = [];
          invoiceTable.forEach(inv => {
            let entries = Object.entries(inv);
            let qtyValue = entries.find(a => a[0].match(/Qty/gi))
            let uomValue = entries.find(a => a[0].match(/UOM/gi))
            let remarksValue = entries.find(a => a[0].match(/Remarks/gi))
            let descriptionValue = entries.find(a => a[0].match(/Description/gi))
            let amtExclValue = entries.find(a => a[0].match(/Amt Excl/gi))
            let currencyValue = entries.find(a => a[0].match(/Currency/gi))
            let exchValue = entries.find(a => a[0].match(/Exch/gi))
            let taxRateValue = entries.find(a => a[0].match(/Tax Rate/gi))
            let taxAmtValue = entries.find(a => a[0].match(/Tax Amt/gi))
            let amtInclValue = entries.find(a => a[0].match(/Amt Incl/gi))

            result.push({
              'Customer Code': f['fullData']['A/C No.'] || '', // A/C No. ==
              'Invoice No.': f['fullData']['Invoice No.'] || '', // Invoice No. ==
              'Invoice Date': f['fullData']['Date'] || '', // Date ==
              'Remarks': f['fullData']['Remarks'] || '', // Remarks == (full data)
              'Credit Term': f['fullData']['Terms'] ? (f['fullData']['Terms'].match(/\d/g) ? f['fullData']['Terms'].match(/\d/g).join('').trim() : '') : '', // Terms == (must get the numbers only)
              'Credit Type': f['fullData']['Terms'] ? (f['fullData']['Terms'].match(/\D/g) ? f['fullData']['Terms'].match(/\D/g).join('').trim() : '') : '', // Terms == (must get the chars only)
              'JobNo': f['fullData']['Job No.'], // Job No. ==
              'CostCode': '', // IGNORE
              'Qty': qtyValue ? qtyValue[1] || '' : '', // (table) Qty ==
              'UOM': uomValue ? uomValue[1] || '' : '', // (table) UOM regex
              'Invoice Remarks': remarksValue ? remarksValue[1] || '' : '', // (table) Remarks regex
              'Group ChargeCode': '', // IGNORE
              'ChargeCode': descriptionValue ? descriptionValue[1] || '' : '', // (table) Description ==
              'Amount': amtExclValue ? amtExclValue[1] || '' : '', // (table) Amt Excl regex
              'Currency': currencyValue ? currencyValue[1] || '' : '', // (table) Currency regex
              'Rate': exchValue ? exchValue[1] || '' : '', // (table) Exch regex
              'Foreign Amount': '', // IGNORE
              'SST Rate': taxRateValue ? taxRateValue[1] || '' : '', // (table) Tax Rate regex
              'SST Amount': taxAmtValue ? taxAmtValue[1] || '' : '', // (table) Tax Amt regex
              'Discount': '', // IGNORE
              'Total Amount': amtInclValue ? amtInclValue[1] || '' : '', // (table) Amt Incl regex
              'File_Name': f['name'],
            })
          })
          return result;
        })
        formattedResult = formattedResult.flat();
        let { r, c } = XLSX.utils.decode_cell('A1');
        let compulsoryHeader = [ 'Customer Code','Invoice No.','Invoice Date','Remarks','Credit Term','Credit Type','ChargeCode','Amount','SST Rate','SST Amount','Total Amount' ];
        let ignoredHeader = [ 'CostCode', 'Group ChargeCode', 'Foreign Amount', 'Discount' ];
        
        let excelData = [
          {
            cell: "A1", // compulsory
            value: formattedResult.flat(),
            headerStyle: {
              font: {
                bold: true,
                color: '255,255,255'
              },
              alignment: {
                horizontal: 'center',
              },
              border: {
                top: { style: 'thin', color: '155,155,155' },
                right: { style: 'thin', color: '155,155,155' },
                bottom: { style: 'thin', color: '155,155,155' },
                left: { style: 'thin', color: '155,155,155' },
              }
            }
          }
        ];

        let keys = Object.keys(formattedResult[0]);
        keys.forEach(k => {
          let fontColor = compulsoryHeader.includes(k) ? '255,0,0' : (ignoredHeader.includes(k) ? '252,136,0' : '0,0,0')
          excelData.push({
            cell: XLSX.utils.encode_cell({ r: r, c: c }),
            value: k,
            style: {
              font: {
                sz: 13,
                bold: true,
                color: fontColor,
              }
            }
          })
          c++;
        })
        await excel.generateAsync(excelData, {
          title: title,
          // fitCol: true,
          tableTheme: '100,100,255',
          rowHighlight: true
        });
      } else { // Create full excel with all the details and all the tables
        let dataToDownload = JSON.parse(JSON.stringify(this.allDataRetrieved));
        //#region Add file name
        dataToDownload = dataToDownload.map((d, i) => {
          return Object.assign({ 'PDF File': this.pdfFiles[i] ? (this.pdfFiles[i]['name'] || 'Testing.pdf') : 'Testing.pdf' }, d);
        })
        //#endregion

        let fullExcelData = [
          {
            cell: 'A1',
            value: title,
            style: {
              font: {
                sz: 18,
                bold: true
              }
            }
          },
          {
            cell: "A3", // compulsory
            value: dataToDownload,
            headerStyle: {
              font: {
                bold: true,
                color: '255,255,255'
              },
              alignment: {
                horizontal: 'center',
              },
              border: {
                top: { style: 'thin', color: '155,155,155' },
                right: { style: 'thin', color: '155,155,155' },
                bottom: { style: 'thin', color: '155,155,155' },
                left: { style: 'thin', color: '155,155,155' },
              }
            }
          }
        ];

        let { c, r } = XLSX.utils.decode_cell('A3');
        r += dataToDownload.length;

        this.pdfFilesTables.forEach(p => {
          //#region Table Title
          r += 2;
          fullExcelData.push({
            cell: XLSX.utils.encode_cell({ c: c, r: r }),
            value: `${p['name']}_TABLES`,
            style: {
              font: {
                bold: true
              }
            }
          });
          //#endregion

          //#region For table details
          r++;
          p.table.forEach(t => {
            fullExcelData.push({
              cell: XLSX.utils.encode_cell({ c: c, r: r }),
              value: t,
              headerStyle: {
                font: {
                  bold: true,
                  color: '255,255,255'
                },
                alignment: {
                  horizontal: 'center',
                },
                border: {
                  top: { style: 'thin', color: '155,155,155' },
                  right: { style: 'thin', color: '155,155,155' },
                  bottom: { style: 'thin', color: '155,155,155' },
                  left: { style: 'thin', color: '155,155,155' },
                }
              }
            })

            c += (Object.keys(t[0]).length + 1);
          });
          r += Math.max(...p.table.map(t => t.length));
          c = 0;
          //#endregion
        })

        await excel.generateAsync(fullExcelData, {
          title: title,
          // fitCol: true,
          tableTheme: '100,100,255',
          rowHighlight: true
        });
      }

      console.log((new Date().getTime() - excelStartDate) / 1000);
      this.isExportingToExcel = false;
    }, 
    checkAndSplitPDF: async function(file) {
      let pdfDoc = await PDFDocument.load(await file.toBase64());
      let pages = pdfDoc.getPages();
      let newFiles = [];
      if (pages.length > 1) {
        for (let x = 0; x < pages.length; x++) {
          let subDoc = await PDFDocument.create();
          let copied = await subDoc.copyPages(pdfDoc, [ x ]);
          copied.forEach(c => subDoc.addPage(c));
          newFiles.push(subDoc);
        }

        let splitFiles = [];
        for (let x = 0; x < newFiles.length; x++) {
          let f = newFiles[x];
          let fileName = file.name.split('.');
          let base64 = await f.saveAsBase64({ dataUri: true });
          splitFiles.push({
            name: `${fileName.slice(0, fileName.length - 1).join('.')}_${x + 1}.pdf`,
            base64: base64,
            file: await this.base64ToFile(base64, `${fileName.slice(0, fileName.length - 1).join('.')}_${x + 1}.pdf`)
          });
        }
        
        return splitFiles;
      } else {
        let base64 = await pdfDoc.saveAsBase64({ dataUri: true });
        return [ {
          name: `${file['name']}`,
          base64: base64,
          file: await this.base64ToFile(base64, file['name'])
        } ];
      }
    },
    base64ToFile: async function(base64, fileName) {
      let buffer = await (await fetch(base64)).arrayBuffer();
      return new File([buffer], fileName, { type: 'application/pdf' });
    },

    //#region Testing for calling multiple APIs concurrently to Google Doc AI
    fileChanged2: async function(e) {
      this.pdfFiles = [];
      this.$fullscreenLoading('Checking Number of pages', true);
      for (let f of Array.from(e)) {
        this.pdfFiles.push(await this.checkAndSplitPDF(f));
      }
      this.pdfFiles = this.pdfFiles.flat();
      this.$fullscreenLoading();

      if (this.pdfFiles.length > 100) {
        this.$showAlert('error', 'Pages Limit Reached', `The total pages from ${e.length} files are ${this.pdfFiles.length} which exceeded the limit of the number of pages allowed (100).`);
      } else {
        let startProcess = await this.$showAlert('warning', 'Confirm Process', `You chose ${e.length} files with a total of ${this.pdfFiles.length} pages.<br><br>Are you sure you want to continue to process these pagees?`, [
          { text: `Process ${this.pdfFiles.length} pages` },
          { text: 'No', textColor: 'white', color: 'red' }
        ])
        
        if (startProcess.includes('Process')) {
          let date = new Date().getTime();
          // let { allForms, allKeys, allTables } = await this.callApiTest();
          let { allForms, allKeys, allTables } = {
            allForms: AllForms, allKeys: AllKeys, allTables: AllTables,
          };
          this.pdfFilesTables = allTables;
          console.log((new Date().getTime() - date) / 1000);
          
          let newForms = Array(allForms.length);
          allKeys = [...new Set(allKeys)];
          for (let x = 0; x < newForms.length; x++) {
            newForms[x] = {};
            allKeys.forEach(h => {
              let hasKey = allForms[x].find(f => f['key'] == h);
              if (h.includes('Job #')) {
                if (hasKey) {
                  let value = hasKey['value'] || '';
                  if (hasKey['value'][1] == '1') {
                    newForms[x][h] = `${value.substring(0,1)}I${value.substring(2)}`;
                  } else {
                    newForms[x][h] = value;
                  }
                } else {
                  newForms[x][h] = '';
                }
              } else {
                newForms[x][h] = hasKey ? hasKey['value'] : '';
              }
            })
          }

          this.headers = allKeys;
          this.allDataRetrieved = newForms;
        }
      }
    },
    callApiTest: async function() {
      let allForms = [];
      let allKeys = [];
      let allTables = [];
      
      let submitted = 1;
      let resolve = null;
      let prom = new Promise(res => resolve = res);

      for (let f of this.pdfFiles) {
        this.$fullscreenLoading(`Uploading ${this.pdfFiles[submitted - 1]['name']} (${submitted} of ${this.pdfFiles.length})`, true);
        let formData = new FormData();
        formData.append('file', f['file']);
        this.$apiCallV2(`/Verification/ReadFile?filename=${f.name}`, formData).then((result) => {
          result['combinedForms'].push({ key: '_uploaded_file_name', value: result['resultFor'] })
          allForms.push(result['combinedForms']);
          allKeys.push(result['combinedForms'].map(c => c['key']));
          allTables.push({ name: result['resultFor'], table: result['formattedResponse'][0]['tables'] || [] });
          submitted++;
          if (submitted > this.pdfFiles.length) {
            allForms = this.$deepTrimJsonV3(allForms);
            allKeys = this.$deepTrimJsonV3(allKeys);
            
            //#region Removing the start and end colon for all the keys
            allKeys = allKeys.flat().map(k => this.removeColon(k));
            //#endregion

            //#region Removing the start and end colon for the the keys and values in each form
            allForms.forEach(form => {
              form.forEach(f => {
                f['key'] = this.removeColon(f['key']);
                f['value'] = this.removeColon(f['value']);
              });
            })
            //#endregion

            this.$fullscreenLoading();
            resolve({
              allForms: allForms,
              allKeys: allKeys,
              allTables: allTables,
            });
          } else {
            this.$fullscreenLoading(`Uploading ${this.pdfFiles[submitted - 1]['name']} (${submitted} of ${this.pdfFiles.length})`, true);
          }
        });
      }

      return prom;
    },
    //#endregion
  },
  mounted() {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.data-retrieval-main {
  padding: 5px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  
  > :not(:first-child) {
    margin-top: 5px;
  }

  > .top-area {
    display: flex;
  }

  > .pdf-area {
    display: flex;
    align-items: center;
    justify-content: center;

    > object {
      width: 100%;
      max-width: 50%;
      height: 100%;
    }

    > .table-by-file-section {
      width: 100%;
      max-width: 50%;
      height: 100%;
      padding: 5px;
      display: flex;
      flex-direction: column;

      > .table-buttons {
        width: 100%;
        height: fit-content;
        overflow: auto;
        display: flex;
        margin-bottom: 5px;

        > button {
          white-space: nowrap;
        }

        > button:not(:first-child) {
          margin-left: 5px;
        }

        > .active-button {
          background-color: rgb(69, 69, 255);
          color: white;
        }
      }
    }
  }
}

.data-retrieval-column-width {
  min-width: 100px;
  max-width: 100px;
  text-align: center;
  white-space: pre-wrap;
  border: 1px solid gray;
  display: flex;
  align-items: center;
  justify-content: center;

  > textarea {
    height: 100%;
    width: 100%;
    resize: none;
    border: none;
    background-color: transparent;

    &:focus {
      outline: none;
    }
  }
}

.column-stick-left {
  position: sticky;
  background-color: white;
  left: 0;
}

.table-area, .pdf-area {
  max-height: 50%;
  height: 100%;
  width: 100%;
  border-radius: 5px;
  border: 1px solid gray;
}

.table-area {
  overflow: auto;

  > .data-retrieval-row {
    display: flex;
    width: fit-content;
  }
}
</style>